module.exports = __webpack_public_path__ + "app/kiss-seller/discarded-identifiers-2Rp1j-Yv.html";